import type { conditionalBlockResult } from '~/types';
import { IconChevronDown, IconChevronRight, IconTerminal } from '@tabler/icons-react';
import { Collapse, Text, UnstyledButton } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

export default function ExecutionStepTextLogsDisplay({
  conditionalBlockResultsForStep,
}: {
  conditionalBlockResultsForStep: conditionalBlockResult[];
}) {
  const [opened, { toggle }] = useDisclosure(false);

  // If there is nothing to show, don't take up any space
  if (conditionalBlockResultsForStep.length === 0) {
    return undefined;
  }

  return (
    <div className="w-full">
      <div className="w-full p-4">
        <div className="ml-4">
          <UnstyledButton
            onClick={toggle}
            className="flex items-center gap-2 rounded-md border border-blue-200 bg-blue-50 px-2.5 py-1.5 text-xs font-medium text-blue-700 transition-colors hover:bg-blue-100 dark:border-blue-800 dark:bg-blue-950/30 dark:text-blue-300 dark:hover:bg-blue-900/40"
          >
            <IconTerminal
              size={14}
              className="flex-shrink-0"
            />
            <span>
              {conditionalBlockResultsForStep.length} conditional log
              {conditionalBlockResultsForStep.length > 1 ? 's' : ''}
            </span>
            {opened ?
              <IconChevronDown
                size={12}
                className="flex-shrink-0 opacity-60"
              />
            : <IconChevronRight
                size={12}
                className="flex-shrink-0 opacity-60"
              />
            }
          </UnstyledButton>
          <Collapse in={opened}>
            <div className="mt-2 space-y-1.5">
              {conditionalBlockResultsForStep.map((log, index) => (
                <div
                  key={index}
                  className="flex items-start gap-2 rounded-md border border-slate-200 bg-slate-50 p-2.5 dark:border-slate-700 dark:bg-slate-800/50"
                >
                  <Text
                    size="xs"
                    className="whitespace-pre-wrap font-mono text-slate-700 dark:text-slate-300"
                  >
                    Conditional prompt: &quot;{log.stepDescription}&quot; resolved to {`${log.resolvedTo}`}
                  </Text>
                </div>
              ))}
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
}
